import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { StudentregisterreportService } from './studentregisterreport.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { global } from '../../shared/global';
import { Studentregmaster } from '../Models/Studentregmaster.model';
import * as XLSX from 'xlsx';
import { state } from '@angular/animations';
declare var $: any;

@Component({
  selector: 'app-studentregisterreport',
  templateUrl: './studentregisterreport.component.html',
  styleUrls: ['./studentregisterreport.component.css']
})
export class StudentregisterreportComponent implements OnInit {
  @ViewChild('StudentRegReport') StudentRegReport: NgForm;
  @ViewChild('TABLE', { static: false }) TABLE: ElementRef;

   p: number = 1; 
   data: Studentregmaster;
   dropDownData: any;
   responseData: any;
  registrationlist: Array<any>;
  pageLimit = global.pageLimit;
  searchtext;
  reverseSort = false;
  dataTable: any;
  isDesc: boolean;
  column: string;
  Status: any;
  states:any;
  cities:any;
  areas:any;
  schools:any;
  SchoolID:any;
  constructor(private service: StudentregisterreportService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router) { }
 
  ngOnInit(): void {

    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    } 
    this.data = new Studentregmaster();
    this.fillState();
    // this.fillCity();
    // this.fillSchoolArea(state,0);
     //this.fillSchoolName(0,0,0);
     //this.cityid=0;
  }
 //document.getElementById("divclgList").style.display = "none";
     
 fillState() {
  const data = {
  };
  this.service.fillState(data)
    .subscribe(data => {
      this.dropDownData = data;
      this.states = this.dropDownData.dropdownlist;
      this.data.StateID=12;
      this.fillCity();
      
    });
}


fillCity() {
  const data = {
    stateID: this.data.StateID
  };
  this.service.fillCity(data)
    .subscribe(data => {
      this.dropDownData = data;
      this.cities = this.dropDownData.dropdownlist;
      if (this.data.CityID == 0 || this.data.CityID == undefined)
       this.data.CityID = 0;
    });
}


  fillSchoolArea(state, city) {
    const data = {
      stateID: state,
      cityID: city
    };
    this.service.fillSchoolArea(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.areas = this.dropDownData.dropdownlist;
        this.data.area = 'Select';
        
        
      });
  }

   
  fillSchoolName(state, city, area) {
    const data = {
      stateID: state,
      cityID: city,
      area: area
    };
    this.service.fillSchoolName(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.schools = this.dropDownData.dropdownlist;
        this.data.SchoolID = 0;
        //this.boards.splice(0, 1);
      });
  }

  onSubmit() {

    if (this.data.StateID == undefined || this.data.StateID == 0) {
      this.toastr.error("Please Select State");
      return
    }
    if (this.data.CityID == undefined || this.data.CityID == 0) {
      this.toastr.error("Please Select City");
      return
    }
     if (this.data.area == undefined || this.data.area == 'Select') {
      this.toastr.error("Please Select area");
      return
    }
     if (this.data.SchoolID == undefined || this.data.SchoolID == 0) {
      this.toastr.error("Please Select school");
      return
    }

    this.spinner.show();
    var objData = {
      
     // status: $("#Status").val()
     State : $("#StateID").val(),
     City  : $("#CityID").val(),
     Area    : $("#area").val(),
     schoolid : $("#SchoolID").val()

    }
    
    this.service.GetStudentRegistrationReportList(objData)
      .subscribe(data => {
        this.responseData = data;
     //   this.p = 1;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
         this.registrationlist = undefined;
        if (this.responseData.status == false) {
          this.toastr.error("Record does not exist!");
          document.getElementById("divclgList").style.display = "none";
          document.getElementById("btnExcel").style.display = "none";
          //document.getElementById("btnfile").style.display = "none";
        } else {
          this.registrationlist = this.responseData.StudentDetList;
          document.getElementById("divclgList").style.display = "block";
          document.getElementById("btnExcel").style.display = "block";
          //document.getElementById("btnfile").style.display = "";
        }
      });
  }

  ExportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.TABLE.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'StudentRegisterReport.xlsx');
  }
   
   
}

